import { useQuery } from '@tanstack/react-query';

import { prophetTypes } from '../types';

import { axios } from '@/libraries/axios';
import { ExtractFnReturnType, QueryConfig } from '@/libraries/react-query';

export const getKeywordRules: prophetTypes.GetKeywordRules = (params) => {
  return axios.get('/prophet/keyword-rules', { params });
};

type QueryFnType = typeof getKeywordRules;

type UseGetKeywordRulesOptions = {
  pageId: string;
  config?: QueryConfig<QueryFnType>;
};

export const useGetKeywordRules = ({ config = {}, pageId }: UseGetKeywordRulesOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ['keyword-rules', pageId],
    queryFn: () => getKeywordRules({ pageId }),
  });
};
